import { useEffect, useState } from "react";
//import { useStyles } from "../../style";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import { Box, FormControlLabel, Grid, IconButton, Tooltip, Typography } 
from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import FilterListIcon from '@mui/icons-material/FilterList';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import dayjs from "dayjs";
import { dashboardText, filterdropdownitem, icon34, lightcolor, paddingbox, pointer, smallText } from "../../style2";

class CustomDate extends Date {
  addDays(days) {
    const date = new CustomDate(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }
}

export default function HealthTracker(props) {
  //const classes = useStyles();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const ls = new AccessLocalStorage();
  const [filterList, setFilterList] = useState([]);
  const [filterDDOpen, setFilterDDOpen] = useState(false);
  const today = new CustomDate();
  const [dateRange, setTrackerDateRange] = useState({ startDate: new CustomDate(today.addDays(-7)), endDate: new CustomDate(today.addDays(7)) })
  //const [datesInRange, setDatesInRange] = useState([]);
  const [journals, setJournalList] = useState([]);
  const [sleepentries, setSleepDiary] = useState([]);
  const [seizureentries, setSeizureDiary] = useState([]);
  const [medications, setMedicationList] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [interventions, setInterventions] = useState([]);


  const trackerFilterOptions = [
    'My Health Diary',
    'Appointments',
    'Medication',
    'Intervention',
    "Seizure Diary",
    "Sleep Diary"
  ];
  const handleFilterChange = (event) => {
    if (event.target.checked) {
      let temp = [...filterList];
      temp.push(event.target.value);
      setFilterList(temp);
    } else
      setFilterList(filterList.filter(t => t != event.target.value));
  };

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    GetInterventions(token);
    GetAppointments(token);
    GetMedicationData(token);
    GetHealthDiary(token, dayjs(dateRange.startDate).format('YYYY-MM-DD'), dayjs(dateRange.endDate).format('YYYY-MM-DD'));
    GetSleepDiary(token, dayjs(dateRange.startDate).format('YYYY-MM-DD'), dayjs(dateRange.endDate).format('YYYY-MM-DD'));
    GetSeizureDiary(token, dayjs(dateRange.startDate).format('YYYY-MM-DD'), dayjs(dateRange.endDate).format('YYYY-MM-DD'));
  }, []);

  const GetInterventions = (token) => {
    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_INTERVENTIONS
      }/${ls.getCurrentPatientId()}/${"416BAF04-ED87-4AB1-90E9-DE13DE602827"}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setInterventions(data);
      })
      .catch((err) => { setError(err.message || "An error occurred."); setInterventions([]); })
      .finally(() => { setLoading(false); });
  };

  const GetAppointments = (token) => {
    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_APPOINTMENTS
      }/${ls.getCurrentPatientId()}/${"F9ED8EC3-492D-4839-B9E4-6E7D7912E98A"}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setAppointments(data);
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
        setAppointments([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const GetMedicationData = (token) => {
    fetch(`${getApiUrl()}${process.env.REACT_APP_GET_MEDICATION}/${ls.getCurrentPatientId()}`,
      { method: "GET", headers: { Authorization: `Bearer ${token}` } }
    )
      .then((response) => response.json())
      .then((data) => {
        let result = [];
        data.forEach((e) => {
          if (!e.isDeleted)
            result.push(e);
        });
        setMedicationList(result);
      })
      .catch((err) => { setError(err.message || "An error occurred."); setMedicationList([]); })
      .finally(() => { setLoading(false); });

  };

  const GetHealthDiary = (token, sd, ed) => {
    setLoading(true);
    fetch(
      `${getApiUrl()}/journal/getbyrange/${ls.getCurrentPatientId()}?startdate=${sd}&enddate=${ed}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then(data => {
            //.log(`Health Diary data from ${dayjs(dateRange.startDate)} till ${dayjs(dateRange.endDate)}`);
            //console.log(data);
            let result = [];
            data.forEach((e) => {
              if (!e.isDeleted)
                result.push(e);
            });
            setJournalList(result);
          });
        }
      })
      .catch((err) => { setError(err.message || "An error occurred."); })
      .finally(() => { setLoading(false); });
  }

  const GetSleepDiary = (token, sd, ed) => {
    setLoading(true);
    fetch(
      `${getApiUrl()}/sleepdiary/getbydate/${ls.getCurrentPatientId()}?sd=${sd}&ed=${ed}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then(data => {
            //console.log('Sleep Diary Data:');
            //console.log(data);
            setSleepDiary(data);
          });
        }
      })
      .catch((err) => { setError(err.message || "An error occurred."); })
      .finally(() => { setLoading(false); });
  }

  const GetSeizureDiary = (token, sd, ed) => {
    setLoading(true);
    fetch(
      `${getApiUrl()}/seizurediary/getbydate/${ls.getCurrentPatientId()}?sd=${sd}&ed=${ed}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then(data => {
            //console.log('Seizure Diary Data:');
            //console.log(data);
            setSeizureDiary(data);
          });
        }
      })
      .catch((err) => { setError(err.message || "An error occurred."); })
      .finally(() => { setLoading(false); });
  }

  const moveDays = (val) => {
    let sd = new CustomDate(dateRange.startDate.addDays(val));
    let ed = new CustomDate(dateRange.endDate.addDays(val));
    setTrackerDateRange({ startDate: sd, endDate: ed });
    //console.log(dateRange);
    //GenerateDateList();

    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
      GetHealthDiary(token, dayjs(sd).format('YYYY-MM-DD'), dayjs(ed).format('YYYY-MM-DD'));
      GetSleepDiary(token, dayjs(sd).format('YYYY-MM-DD'), dayjs(ed).format('YYYY-MM-DD'));
      GetSeizureDiary(token, dayjs(sd).format('YYYY-MM-DD'), dayjs(ed).format('YYYY-MM-DD'));
    }

  }

  const getMonthName = (month) => {
    switch (month) {
      case 0:
        return "Jan";
      case 1:
        return "Feb";
      case 2:
        return "Mar";
      case 3:
        return "Apr";
      case 4:
        return "May";
      case 5:
        return "Jun";
      case 6:
        return "Jul";
      case 7:
        return "Aug";
      case 8:
        return "Sep";
      case 9:
        return "Oct";
      case 10:
        return "Nov";
      case 11:
        return "Dec";
    }
  }

  const renderMedicationDot = () => {
    return <span
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "24px",
        height: "24px",
        background: "transparent",
        //marginBottom: "8px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          background: "#5CE1E6",
          borderRadius: "50%",
        }}
      ></span>
    </span>;
  }

  const renderInterventionDot = () => {
    return <span
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "24px",
        height: "24px",
        background: "transparent",
        //marginBottom: "8px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          background: "#004AAD",
          borderRadius: "50%",
        }}
      ></span>
    </span>;
  }

  const renderJournalDot = () => {
    return <span
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "24px",
        height: "24px",
        background: "transparent",
        //marginBottom: "8px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          background: "#E22A57",
          borderRadius: "50%",
        }}
      ></span>
    </span>;
  }

   const renderSleepDiaryDot = () => {
    return <span
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "24px",
        height: "24px",
        background: "transparent",
        //marginBottom: "8px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          background: "#A78BFA",
          borderRadius: "50%",
        }}
      ></span>
    </span>;
  }

  const renderSeizureDiaryDot = () => {
    return <span
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "24px",
        height: "24px",
        background: "transparent",
        //marginBottom: "8px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          background: "#8B008B",
          borderRadius: "50%",
        }}
      ></span>
    </span>;
  }

  const renderAppointmentDot = () => {
    return <span
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "24px",
        height: "24px",
        background: "transparent",
        //marginBottom: "8px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          background: "#FFBD59",
          borderRadius: "50%",
        }}
      ></span>
    </span>;
  }

  const renderJournals = (date) => {
    let ccfilter = filterList.join(",");
    if ((ccfilter !== "" && ccfilter.indexOf("My Health Diary") > -1) || ccfilter === "") {
      let temp = [];
      for (let k in journals) {
        let j = new Date(journals[k].journalDate);
        if (j.getFullYear() === date.getFullYear() && j.getMonth() === date.getMonth() && j.getDate() === date.getDate()) {
          temp.push(journals[k]);
        }
      }
      return <>{temp.map((e) => {
        return <div style={{ marginBottom: "0.85rem" }}>
          {renderJournalDot()}
          {/* <span style={{ fontSize: "0.7rem", marginTop: "4px", maxWidth: "79px", display: "block" }}>My Health Diary</span> */}
        </div>;
      })}</>;
    }
    else
      return null;
  }

  const renderSleepDiaries = (date) => {
    let ccfilter = filterList.join(",");
    if ((ccfilter !== "" && ccfilter.indexOf("Sleep Diary") > -1) || ccfilter === "") {
      let temp = [];
      for (let k in sleepentries) {
        let j = new Date(sleepentries[k].journalDate);
        if (j.getFullYear() === date.getFullYear() && j.getMonth() === date.getMonth() && j.getDate() === date.getDate()) {
          temp.push(sleepentries[k]);
        }
      }
      return <>{temp.map((e) => {
        return <div style={{ marginBottom: "0.85rem" }}>
          {renderSleepDiaryDot()}
        </div>;
      })}</>;
    }
    else
      return null;
  }

  const renderSeizureDiaries = (date) => {
    let ccfilter = filterList.join(",");
    if ((ccfilter !== "" && ccfilter.indexOf("Sleep Diary") > -1) || ccfilter === "") {
      let temp = [];
      for (let k in seizureentries) {
        let j = new Date(seizureentries[k].entryDate);
        if (j.getFullYear() === date.getFullYear() && j.getMonth() === date.getMonth() && j.getDate() === date.getDate()) {
          temp.push(seizureentries[k]);
        }
      }
      return <>{temp.map((e) => {
        return <div style={{ marginBottom: "0.85rem" }}>
          {renderSeizureDiaryDot()}
        </div>;
      })}</>;
    }
    else
      return null;
  }

  const renderAppointments = (date) => {
    let ccfilter = filterList.join(",");
    if ((ccfilter !== "" && ccfilter.indexOf("Appointments") > -1) || ccfilter === "") {
      let temp = [];
      for (let k in appointments) {
        let j = new Date(appointments[k].startDate);
        if (j.getFullYear() === date.getFullYear() && j.getMonth() === date.getMonth() && j.getDate() === date.getDate()) {
          temp.push(appointments[k]);
        }
      }
      return <>{temp.map((e) => {
        return <Tooltip title={e.title + " at " + dayjs(e.startDate).format("DD/MM/YYYY h:mm A")}>
          <div style={{ marginBottom: "20px" }}>
            {renderAppointmentDot()}
          </div>
        </Tooltip>;
      })}</>;
    } else { return null; }
  }

  const renderInterventions = (date) => {
    let ccfilter = filterList.join(",");
    if ((ccfilter !== "" && ccfilter.indexOf("Intervention") > -1) || ccfilter === "") {
      let temp = [];
      for (let k in interventions) {
        let j = new Date(interventions[k].startDate);
        if (j.getFullYear() === date.getFullYear() && j.getMonth() === date.getMonth() && j.getDate() === date.getDate()) {
          temp.push(interventions[k]);
        }
      }
      return <>{temp.map((e) => {
        return <Tooltip title={e.title + " at " + dayjs(e.startDate).format("DD/MM/YYYY h:mm A")}>
          <div style={{ marginBottom: "20px" }}>
            {renderInterventionDot()}
          </div>
        </Tooltip>;
      })}</>;
    } else {
      return null;
    }
  }

  const renderMedications = (date) => {
    let ccfilter = filterList.join(",");
    if ((ccfilter !== "" && ccfilter.indexOf("Medication") > -1) || ccfilter === "") {
      let temp = [];
      for (let k in medications.filter(t => t.medicationDates.length > 0)) {
        for (let i in medications[k].medicationDates) {
          let sd = new Date(medications[k].medicationDates[i].startDate);
          let ed = new Date(medications[k].medicationDates[i].endDate);
          if (sd <= date && ed >= date) {
            temp.push(medications[k]);
            break;
          }
        }
      }
      return <>{temp.map((e) => {
        return <Tooltip title={e.medicineName}>
          <div style={{ marginBottom: "20px" }}>
            {renderMedicationDot()}
          </div>
        </Tooltip>;
      })}</>;
    } else {
      return null;
    }
  }

  const renderTrackerDateRange = () => {
    const startMonth = getMonthName(dateRange.startDate.getMonth());
    const endMonth = getMonthName(dateRange.endDate.getMonth());
    const startYear = dateRange.startDate.getFullYear();
    const endYear = dateRange.endDate.getFullYear();

    if (startYear === endYear && dateRange.startDate.getMonth() === dateRange.endDate.getMonth()) {
      // Same month and year
      return `${startMonth} ${startYear}`;
    } else if (startYear === endYear) {
      // Different months, same year
      return `${startMonth} - ${endMonth} ${startYear}`;
    } else {
      // Different years
      return `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
    }
  };

  const renderDateList = () => {
    let loopDate = new CustomDate(dateRange.startDate);
    let temp = [];
    temp.push(loopDate);
    while (loopDate < dateRange.endDate) {
      loopDate = new CustomDate(loopDate.addDays(1))
      temp.push(loopDate);
    }
    return temp.map((e, index) => {
      let colBgColor = index % 2 == 0 ? "#F1EFDF" : "#ffffff";

      return <td align="center" valign="top" style={{ background: colBgColor, padding: "10px 2px", width: "6.6%" }}>
        <Tooltip title={dayjs(e).format("DD/MM/YYYY")}>
          <span
            style={{
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "0.9rem",
              width: "30px",
              height: "30px",
              minWidth: "28px",
              minHeight: "28px",
              background: "#fff",
              borderRadius: "50%",
              marginBottom: "20px",
              padding: "6px",
              boxSizing: "border-box",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            {e.getDate().toString()}
          </span>
        </Tooltip>
        {renderJournals(e)}
        {renderAppointments(e)}
        {renderInterventions(e)}
        {renderMedications(e)}
        {renderSeizureDiaries(e)}
        {renderSleepDiaries(e)}
      </td>;
    })
  }

  const renderLegends = () => {
    return <Box style={{ padding: "10px 0px", textAlign: "center" }}>
      {renderAppointmentDot()}
      <Box component="span" sx={{ display: "inline-block", margin: "0px 10px", ...smallText }}>Appointments</Box>
      {renderInterventionDot()}
      <Box component="span" sx={{ display: "inline-block", margin: "0px 10px", ...smallText }}>Interventions</Box>
      {renderMedicationDot()}
      <Box component="span" sx={{ display: "inline-block", margin: "0px 10px", ...smallText }}>Medication</Box>
      {renderJournalDot()}
      <Box component="span" sx={{ display: "inline-block", margin: "0px 10px", ...smallText }}>Health Diary</Box>
      {renderSleepDiaryDot()}
      <Box component="span" sx={{ display: "inline-block", margin: "0px 10px", ...smallText }}>Sleep Diary</Box>
      {renderSeizureDiaryDot()}
      <Box component="span" sx={{ display: "inline-block", margin: "0px 10px", ...smallText }}>Seizure Diary</Box>
    </Box>
  }


  return (<Box sx={paddingbox} id={props.id}>
    <Grid container>
      <Grid item xs={12} container>
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" sx={dashboardText}>
            <Box component="img" src="assets/date.png" sx={icon34}></Box> <Box mr={1} /><Typography sx={dashboardText} variant="h6" component="div" marginLeft={1}>Activity Tracker</Typography>
          </Box>
        </Grid>
        <Grid item xs={6} container direction="column" alignItems="flex-end" justifyContent="flex-end" sx={pointer}>
          <div style={{ position: "relative" }}>
            <div direction="column" alignItems="middle" justifyContent="center">
              <IconButton onClick={() => { setFilterDDOpen(!filterDDOpen) }}><FilterListIcon /></IconButton>
            </div>
            {filterDDOpen ? <Box sx={{ width:"200px", position: "absolute", right: "0", borderRadius: "15px", border: "1px solid #fff", backgroundColor: lightcolor, padding: "10px", zIndex: 2 }}>
              {trackerFilterOptions.map((e) => {
                return (
                  <FormControlLabel sx={filterdropdownitem} control={<Checkbox defaultChecked={filterList.filter(t => t === e).length != 0}
                    value={e} onChange={handleFilterChange} />} label={e} labelPlacement="end" />
                );
              })}
            </Box> : null}
          </div>
        </Grid>
      </Grid> 
      {filterList.length > 0 ? <Box component="div" item xs={12} sx={{ margin: "5px 0px" }}>
        {filterList.map((e) => { return (<Box component="span" sx={{ backgroundColor: "#EEEEEE", fontSize: "0.7rem", padding: "4px 20px", marginRight: "20px", border: "1px solid #717273", borderRadius: "15px" }}>{e}</Box>); })}
      </Box> : null}
      <Grid item xs={12} sx={{ borderRadius: "15px", border: "1px solid #fff", backgroundColor: lightcolor, padding: "10px" }}>
        <Typography sx={{ textAlign: "center", fontWeight: "bold", fontSize: "1.3rem", marginBottom: "10px" }}>
          {renderTrackerDateRange()}
        </Typography>
        <table border="0" style={{ width: "100%", minHeight: "400px" }}>
          <tbody>
            <tr>
              <td valign="middle" align="center" style={{ padding: "0", width: "20px" }}>
                <IconButton disabled={loading} aria-label="Move Left" onClick={() => {
                  moveDays(-7);
                }}>
                  <ChevronLeftIcon sx={pointer} style={{ fontSize: "2rem" }} />
                </IconButton>
              </td>
              {renderDateList()}
              <td valign="middle" align="center" style={{ padding: "0", width: "20px" }}>
                <IconButton disabled={loading} aria-label="Move Right" onClick={() => {
                  moveDays(7);
                }}>
                  <ChevronRightIcon sx={pointer} style={{ fontSize: "2rem" }} />
                </IconButton>
              </td>
            </tr>
          </tbody>
        </table>
        {renderLegends()}
      </Grid>
    </Grid>
  </Box>);
}
